import { render, staticRenderFns } from "./CreateEditDashboard.vue?vue&type=template&id=cde305e0&"
import script from "./CreateEditDashboard.vue?vue&type=script&lang=js&"
export * from "./CreateEditDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports